import { Controller } from "@hotwired/stimulus"

// Validates refund amount: must be > 0 and <= max refundable.
export default class extends Controller {
  static targets = ["amount", "submit", "error"]
  static values = { max: { type: Number, default: 0 } }

  connect() {
    this.validate()
  }

  validate() {
    const max = this.maxValue || parseFloat(this.element.dataset.refundFormMaxValue || 0)
    const val = parseFloat(this.amountTarget?.value || 0)
    let valid = true
    let message = ""

    if (val <= 0) {
      valid = false
      message = "Amount must be greater than zero."
    } else if (val > max) {
      valid = false
      message = `Amount cannot exceed $${max.toFixed(2)}.`
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !valid
    }
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.toggle("hidden", valid)
    }
  }
}
